<template>
  <v-container>
    <v-card>
      <payslip-monthly-payslip :employee-uid="employee.employee_uid" />
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      PayslipMonthlyPayslip: () => import('@/components/payslip/MonthlyPayslip'),
    },
    metaInfo () {
      return {
        title: 'Payslip',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
